import { render, staticRenderFns } from "./ShopWindow.vue?vue&type=template&id=c074dcc0"
import script from "./ShopWindow.vue?vue&type=script&lang=js"
export * from "./ShopWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports